import type { Category } from "@/constants/categories";

type PerfumeProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  perfume:
    "https://images.unsplash.com/photo-1608721279136-cd41b752fa41?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
): PerfumeProduct => ({
  id,
  name,
  categorySlug: "perfumes",
  brand,
  unit,
  price,
  image: IMG.perfume,
});

export const PERFUME_PRODUCTS: PerfumeProduct[] = [
  item("per-dc-24-pure-men", "DC 24 Pure for Men", "Dorall Collection", "100ml", 24.99),
  item("per-dc-express-women", "DC Express Women", "Dorall Collection", "100ml", 24.99),
  item("per-dc-one-gold", "DC One Gold", "Dorall Collection", "100ml", 24.99),
  item("per-dc-pattern", "DC Pattern", "Dorall Collection", "100ml", 24.99),
  item("per-dc-pattison-men", "DC Pattison for Men", "Dorall Collection", "100ml", 24.99),
  item("per-dc-sile-tri-men", "DC Sile Tri for Men", "Dorall Collection", "100ml", 24.99),
  item("per-dc-speculus-men", "DC Speculus for Men", "Dorall Collection", "100ml", 24.99),
  item("per-dc-super-cobra-women", "DC Super Cobra for Women", "Dorall Collection", "100ml", 24.99),
  item("per-dc-smart-secrets-women", "DC Smart Secrets Women", "Dorall Collection", "100ml", 24.99),
  item("per-dc-fleur-de-lamour-women", "DC Fleur de L'Amour Women", "Dorall Collection", "100ml", 24.99),
  item("per-dc-vintage-garden-women", "DC Vintage Garden for Women", "Dorall Collection", "100ml", 24.99),
  item("per-dc-wild-hunter-men", "DC Wild Hunter for Men", "Dorall Collection", "100ml", 24.99),
  item("per-dc-hey", "Dorall Collection Hey", "Dorall Collection", "100ml", 19.99),
];
